import * as i0 from "@angular/core";
var AnulacionZonaServiceAuto = /** @class */ (function () {
    function AnulacionZonaServiceAuto() {
    }
    AnulacionZonaServiceAuto.ngInjectableDef = i0.defineInjectable({ factory: function AnulacionZonaServiceAuto_Factory() { return new AnulacionZonaServiceAuto(); }, token: AnulacionZonaServiceAuto, providedIn: "root" });
    return AnulacionZonaServiceAuto;
}());
export { AnulacionZonaServiceAuto };
